import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Table } from "react-bootstrap";
import {
  ArrowRightCircleFill,
  CheckCircle,
  DatabaseExclamation,
} from "react-bootstrap-icons";
import batchSummarygql from "gql/dashboard/sales/batchSummary.gql";
import { useLazyQuery } from "@apollo/client";
import Loading from "components/Loading";
import DateFormat from "components/DateFormat";
import { useFormContext } from "contexts/FormContext";
import { toast } from "react-toastify";
import parse from "html-react-parser";

const ItemBatchSummary = ({ item }) => {
  // contexts
  const [getSummary, { loading, data, error }] = useLazyQuery(batchSummarygql, {
    variables: { item: item.id },
  });
  const { formState, setFormState } = useFormContext();

  // states
  const [batchModal, setBatchModal] = useState(false);

  // hooks

  // functions
  const fetchBatchSummary = () => {
    setBatchModal(true);
    getSummary();
  };

  const addToRemark = (ib) => {
    setFormState({
      key: "info.remarks",
      value: `${formState.info.remarks}${
        formState.info.remarks && "\n"
      }Please use ItemBatch ${ib.batchNumber} for ${item.displayName}`,
    });
  };

  // effects
  useEffect(() => {
    if (!loading && error) {
      toast.error(<p>{parse(error.message)}</p>);
    }
  }, [loading]);

  return (
    <React.Fragment>
      <Button
        style={{ backgroundColor: "#AD6704" }}
        className="w-100 border-0"
        onClick={fetchBatchSummary}
      >
        <DatabaseExclamation size={16}/>
      </Button>

      <Modal size="lg" show={batchModal} onHide={() => setBatchModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Item Batch Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && <Loading />}
          {!loading && data && (
            <React.Fragment>
              <h6 className="bg-warning rounded bg-opacity-50 p-2 w-fit-content">
                Reserved Qty:{" "}
                {data.items.length && data.items[0].reservedQuantity}{" "}
                <span className="small">{item.uom?.name}</span>
              </h6>
              <h6 className="bg-warning rounded bg-opacity-50 p-2 w-fit-content">
                Pending Release Qty:{" "}
                {data.items.length && data.items[0].pendingReleaseQuantity}{" "}
                <span className="small">{item.uom?.name}</span>
              </h6>
              <Table striped hover responsive className="text-center">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Batch Number</th>
                    <th>Inventory Level</th>
                    <th>Expiry Date</th>
                    <th>Add to Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {data.items.length &&
                    data.items[0].distinctItemBatches
                      ?.filter((x) => x.inventoryLevel > 0)
                      .sort((a, b) => (a.expiryDate > b.expiryDate ? 1 : -1))
                      .map((ib, index) => (
                        <tr key={ib.id}>
                          <td>{index + 1}</td>
                          <td>{ib.batchNumber}</td>
                          <td>
                            {ib.inventoryLevel}{" "}
                            <span className="small">{item.uom?.name}</span>
                          </td>
                          <td>
                            {ib.expiryDate && (
                              <DateFormat value={ib.expiryDate} />
                            )}
                          </td>
                          <td>
                            {!formState.info.remarks.includes(
                              ib.batchNumber
                            ) && (
                              <ArrowRightCircleFill
                                className="clickable"
                                size={25}
                                color="#AD6704"
                                onClick={() => addToRemark(ib)}
                              />
                            )}
                            {formState.info.remarks.includes(
                              ib.batchNumber
                            ) && <CheckCircle size={25} color="#1AB394" />}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </Table>
            </React.Fragment>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ItemBatchSummary;
